<script>
export default {
  name: 'responsive',
  data () {
    return {
      mobileViewport: null,
      desktopViewport: null,
      isMobile: false,
      isTablet: false,
      isDesktop: false
    };
  },
  mounted () {
    this.mobileViewport = window.matchMedia('screen and (max-width: 640px)');
    this.tabletViewport = window.matchMedia('screen and (min-width: 641px) and (max-width: 1040px)');
    this.desktopViewport = window.matchMedia('screen and (min-width: 1041px)');
    this.mobileViewport.addListener(this.detectMobileViewport);
    this.tabletViewport.addListener(this.detectTabletViewport);
    this.desktopViewport.addListener(this.detectDesktopViewport);

    if (this.mobileViewport.matches) {
      this.isMobile = true;
    }

    if (this.tabletViewport.matches) {
      this.isTablet = true;
    }

    if (this.desktopViewport.matches) {
      this.isDesktop = true;
    }
  },
  methods: {
    detectMobileViewport (mq) {
      if (mq.matches) {
        this.isMobile = true;
        this.isTablet = false;
        this.isDesktop = false;
      }
    },
    detectTabletViewport (mq) {
      if (mq.matches) {
        this.isMobile = false;
        this.isTablet = true;
        this.isDesktop = false;
      }
    },
    detectDesktopViewport (mq) {
      if (mq.matches) {
        this.isMobile = false;
        this.isTablet = false;
        this.isDesktop = true;
      }
    }
  },
  beforeDestroy () {
    this.mobileViewport.removeListener(this.detectMobileViewport);
    this.tabletViewport.removeListener(this.detectTabletViewport);
    this.desktopViewport.removeListener(this.detectDesktopViewport);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/Responsive.vue